import React from 'react';
import Breadcrumb from 'Common/BreadCrumb';
import { Card, Col, Container, Row } from 'react-bootstrap';

const PhosphorIcon = () => {
    document.title=" Phosphor Icons | Steex Admin & Dashboard Template";


  return (
    <React.Fragment>
    <div className="page-content">       
        <Container fluid>
            <Breadcrumb pageTitle="Icons" title="Phosphor" />
            <Row>
                <Col className="col-12">
                    <Card>
                        <Card.Header>
                            <h4 className="card-title">Examples</h4>
                            <p className="text-muted mb-0">Use <code>&lt;i className="ph-**"{'>'}&lt;/i{'>'}</code> class.</p>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            <Row className="icon-demo-content" id="iconList">
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-activity-thin"></i> ph-activity-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-address-book-thin"></i> ph-address-book-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-airplane-in-flight-thin"></i> ph-airplane-in-flight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-airplane-landing-thin"></i> ph-airplane-landing-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-airplane-takeoff-thin"></i> ph-airplane-takeoff-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-airplane-thin"></i> ph-airplane-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-airplane-tilt-thin"></i> ph-airplane-tilt-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-airplay-thin"></i> ph-airplay-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-alarm-thin"></i> ph-alarm-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-alien-thin"></i> ph-alien-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-bottom-simple-thin"></i> ph-align-bottom-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-bottom-thin"></i> ph-align-bottom-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-center-horizontal-simple-thin"></i> ph-align-center-horizontal-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-center-horizontal-thin"></i> ph-align-center-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-center-vertical-simple-thin"></i> ph-align-center-vertical-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-center-vertical-thin"></i> ph-align-center-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-left-simple-thin"></i> ph-align-left-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-left-thin"></i> ph-align-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-right-simple-thin"></i> ph-align-right-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-right-thin"></i> ph-align-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-top-simple-thin"></i> ph-align-top-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-align-top-thin"></i> ph-align-top-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-anchor-simple-thin"></i> ph-anchor-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-anchor-thin"></i> ph-anchor-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-android-logo-thin"></i> ph-android-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-angular-logo-thin"></i> ph-angular-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-aperture-thin"></i> ph-aperture-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-app-store-logo-thin"></i> ph-app-store-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-app-window-thin"></i> ph-app-window-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-apple-logo-thin"></i> ph-apple-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-apple-podcasts-logo-thin"></i> ph-apple-podcasts-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-archive-box-thin"></i> ph-archive-box-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-archive-thin"></i> ph-archive-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-archive-tray-thin"></i> ph-archive-tray-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-armchair-thin"></i> ph-armchair-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-arc-left-thin"></i> ph-arrow-arc-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-arc-right-thin"></i> ph-arrow-arc-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-double-up-left-thin"></i> ph-arrow-bend-double-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-double-up-right-thin"></i> ph-arrow-bend-double-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-down-left-thin"></i> ph-arrow-bend-down-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-down-right-thin"></i> ph-arrow-bend-down-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-left-down-thin"></i> ph-arrow-bend-left-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-left-up-thin"></i> ph-arrow-bend-left-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-right-down-thin"></i> ph-arrow-bend-right-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-right-up-thin"></i> ph-arrow-bend-right-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-up-left-thin"></i> ph-arrow-bend-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-bend-up-right-thin"></i> ph-arrow-bend-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-down-left-thin"></i> ph-arrow-circle-down-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-down-right-thin"></i> ph-arrow-circle-down-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-down-thin"></i> ph-arrow-circle-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-left-thin"></i> ph-arrow-circle-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-right-thin"></i> ph-arrow-circle-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-up-left-thin"></i> ph-arrow-circle-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-up-right-thin"></i> ph-arrow-circle-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-circle-up-thin"></i> ph-arrow-circle-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-clockwise-thin"></i> ph-arrow-clockwise-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-counter-clockwise-thin"></i> ph-arrow-counter-clockwise-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-down-left-thin"></i> ph-arrow-down-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-down-right-thin"></i> ph-arrow-down-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-down-thin"></i> ph-arrow-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-down-left-thin"></i> ph-arrow-elbow-down-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-down-right-thin"></i> ph-arrow-elbow-down-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-left-down-thin"></i> ph-arrow-elbow-left-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-left-thin"></i> ph-arrow-elbow-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-left-up-thin"></i> ph-arrow-elbow-left-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-right-down-thin"></i> ph-arrow-elbow-right-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-right-thin"></i> ph-arrow-elbow-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-right-up-thin"></i> ph-arrow-elbow-right-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-up-left-thin"></i> ph-arrow-elbow-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-elbow-up-right-thin"></i> ph-arrow-elbow-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-down-thin"></i> ph-arrow-fat-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-left-thin"></i> ph-arrow-fat-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-line-down-thin"></i> ph-arrow-fat-line-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-line-left-thin"></i> ph-arrow-fat-line-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-line-right-thin"></i> ph-arrow-fat-line-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-line-up-thin"></i> ph-arrow-fat-line-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-lines-down-thin"></i> ph-arrow-fat-lines-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-lines-left-thin"></i> ph-arrow-fat-lines-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-lines-right-thin"></i> ph-arrow-fat-lines-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-lines-up-thin"></i> ph-arrow-fat-lines-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-right-thin"></i> ph-arrow-fat-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-fat-up-thin"></i> ph-arrow-fat-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-left-thin"></i> ph-arrow-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-down-left-thin"></i> ph-arrow-line-down-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-down-right-thin"></i> ph-arrow-line-down-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-down-thin"></i> ph-arrow-line-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-left-thin"></i> ph-arrow-line-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-right-thin"></i> ph-arrow-line-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-up-left-thin"></i> ph-arrow-line-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-up-right-thin"></i> ph-arrow-line-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-line-up-thin"></i> ph-arrow-line-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-right-thin"></i> ph-arrow-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-down-left-thin"></i> ph-arrow-square-down-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-down-right-thin"></i> ph-arrow-square-down-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-down-thin"></i> ph-arrow-square-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-in-thin"></i> ph-arrow-square-in-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-left-thin"></i> ph-arrow-square-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-out-thin"></i> ph-arrow-square-out-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-right-thin"></i> ph-arrow-square-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-up-left-thin"></i> ph-arrow-square-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-up-right-thin"></i> ph-arrow-square-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-square-up-thin"></i> ph-arrow-square-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-down-left-thin"></i> ph-arrow-u-down-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-down-right-thin"></i> ph-arrow-u-down-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-left-down-thin"></i> ph-arrow-u-left-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-left-up-thin"></i> ph-arrow-u-left-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-right-down-thin"></i> ph-arrow-u-right-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-right-up-thin"></i> ph-arrow-u-right-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-up-left-thin"></i> ph-arrow-u-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-u-up-right-thin"></i> ph-arrow-u-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-up-left-thin"></i> ph-arrow-up-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-up-right-thin"></i> ph-arrow-up-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrow-up-thin"></i> ph-arrow-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-clockwise-thin"></i> ph-arrows-clockwise-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-counter-clockwise-thin"></i> ph-arrows-counter-clockwise-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-down-up-thin"></i> ph-arrows-down-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-horizontal-thin"></i> ph-arrows-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-in-cardinal-thin"></i> ph-arrows-in-cardinal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-in-line-horizontal-thin"></i> ph-arrows-in-line-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-in-line-vertical-thin"></i> ph-arrows-in-line-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-in-simple-thin"></i> ph-arrows-in-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-in-thin"></i> ph-arrows-in-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-left-right-thin"></i> ph-arrows-left-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-out-cardinal-thin"></i> ph-arrows-out-cardinal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-out-line-horizontal-thin"></i> ph-arrows-out-line-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-out-line-vertical-thin"></i> ph-arrows-out-line-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-out-simple-thin"></i> ph-arrows-out-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-out-thin"></i> ph-arrows-out-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-arrows-vertical-thin"></i> ph-arrows-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-article-medium-thin"></i> ph-article-medium-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-article-ny-times-thin"></i> ph-article-ny-times-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-article-thin"></i> ph-article-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-asterisk-simple-thin"></i> ph-asterisk-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-asterisk-thin"></i> ph-asterisk-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-at-thin"></i> ph-at-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-atom-thin"></i> ph-atom-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-baby-thin"></i> ph-baby-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-backpack-thin"></i> ph-backpack-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-backspace-thin"></i> ph-backspace-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bag-simple-thin"></i> ph-bag-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bag-thin"></i> ph-bag-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-balloon-thin"></i> ph-balloon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bandaids-thin"></i> ph-bandaids-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bank-thin"></i> ph-bank-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-barbell-thin"></i> ph-barbell-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-barcode-thin"></i> ph-barcode-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-barricade-thin"></i> ph-barricade-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-baseball-thin"></i> ph-baseball-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-basketball-thin"></i> ph-basketball-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bathtub-thin"></i> ph-bathtub-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-charging-thin"></i> ph-battery-charging-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-charging-vertical-thin"></i> ph-battery-charging-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-empty-thin"></i> ph-battery-empty-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-full-thin"></i> ph-battery-full-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-high-thin"></i> ph-battery-high-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-low-thin"></i> ph-battery-low-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-medium-thin"></i> ph-battery-medium-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-plus-thin"></i> ph-battery-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-warning-thin"></i> ph-battery-warning-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-battery-warning-vertical-thin"></i> ph-battery-warning-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bed-thin"></i> ph-bed-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-beer-bottle-thin"></i> ph-beer-bottle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-behance-logo-thin"></i> ph-behance-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-ringing-thin"></i> ph-bell-ringing-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-simple-ringing-thin"></i> ph-bell-simple-ringing-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-simple-slash-thin"></i> ph-bell-simple-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-simple-thin"></i> ph-bell-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-simple-z-thin"></i> ph-bell-simple-z-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-slash-thin"></i> ph-bell-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-thin"></i> ph-bell-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bell-z-thin"></i> ph-bell-z-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bezier-curve-thin"></i> ph-bezier-curve-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bicycle-thin"></i> ph-bicycle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-binoculars-thin"></i> ph-binoculars-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bird-thin"></i> ph-bird-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bluetooth-connected-thin"></i> ph-bluetooth-connected-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bluetooth-slash-thin"></i> ph-bluetooth-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bluetooth-thin"></i> ph-bluetooth-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bluetooth-x-thin"></i> ph-bluetooth-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-boat-thin"></i> ph-boat-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-book-bookmark-thin"></i> ph-book-bookmark-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-book-open-thin"></i> ph-book-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-book-thin"></i> ph-book-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bookmark-simple-thin"></i> ph-bookmark-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bookmark-thin"></i> ph-bookmark-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bookmarks-simple-thin"></i> ph-bookmarks-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bookmarks-thin"></i> ph-bookmarks-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-books-thin"></i> ph-books-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bounding-box-thin"></i> ph-bounding-box-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-brackets-angle-thin"></i> ph-brackets-angle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-brackets-curly-thin"></i> ph-brackets-curly-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-brackets-round-thin"></i> ph-brackets-round-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-brackets-square-thin"></i> ph-brackets-square-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-brain-thin"></i> ph-brain-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-brandy-thin"></i> ph-brandy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-briefcase-metal-thin"></i> ph-briefcase-metal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-briefcase-thin"></i> ph-briefcase-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-broadcast-thin"></i> ph-broadcast-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-browser-thin"></i> ph-browser-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-browsers-thin"></i> ph-browsers-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bug-beetle-thin"></i> ph-bug-beetle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bug-droid-thin"></i> ph-bug-droid-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bug-thin"></i> ph-bug-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-buildings-thin"></i> ph-buildings-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-bus-thin"></i> ph-bus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-butterfly-thin"></i> ph-butterfly-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cactus-thin"></i> ph-cactus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cake-thin"></i> ph-cake-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-calculator-thin"></i> ph-calculator-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-calendar-blank-thin"></i> ph-calendar-blank-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-calendar-check-thin"></i> ph-calendar-check-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-calendar-plus-thin"></i> ph-calendar-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-calendar-thin"></i> ph-calendar-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-calendar-x-thin"></i> ph-calendar-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-camera-rotate-thin"></i> ph-camera-rotate-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-camera-slash-thin"></i> ph-camera-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-camera-thin"></i> ph-camera-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-campfire-thin"></i> ph-campfire-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-car-simple-thin"></i> ph-car-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-car-thin"></i> ph-car-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cardholder-thin"></i> ph-cardholder-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cards-thin"></i> ph-cards-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-double-down-thin"></i> ph-caret-circle-double-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-double-left-thin"></i> ph-caret-circle-double-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-double-right-thin"></i> ph-caret-circle-double-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-double-up-thin"></i> ph-caret-circle-double-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-down-thin"></i> ph-caret-circle-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-left-thin"></i> ph-caret-circle-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-right-thin"></i> ph-caret-circle-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-circle-up-thin"></i> ph-caret-circle-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-double-down-thin"></i> ph-caret-double-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-double-left-thin"></i> ph-caret-double-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-double-right-thin"></i> ph-caret-double-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-double-up-thin"></i> ph-caret-double-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-down-thin"></i> ph-caret-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-left-thin"></i> ph-caret-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-right-thin"></i> ph-caret-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-caret-up-thin"></i> ph-caret-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cat-thin"></i> ph-cat-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cell-signal-full-thin"></i> ph-cell-signal-full-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cell-signal-high-thin"></i> ph-cell-signal-high-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cell-signal-low-thin"></i> ph-cell-signal-low-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cell-signal-medium-thin"></i> ph-cell-signal-medium-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cell-signal-none-thin"></i> ph-cell-signal-none-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cell-signal-slash-thin"></i> ph-cell-signal-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cell-signal-x-thin"></i> ph-cell-signal-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chalkboard-simple-thin"></i> ph-chalkboard-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chalkboard-teacher-thin"></i> ph-chalkboard-teacher-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chalkboard-thin"></i> ph-chalkboard-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chart-bar-horizontal-thin"></i> ph-chart-bar-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chart-bar-thin"></i> ph-chart-bar-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chart-line-thin"></i> ph-chart-line-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chart-line-up-thin"></i> ph-chart-line-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chart-pie-slice-thin"></i> ph-chart-pie-slice-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chart-pie-thin"></i> ph-chart-pie-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-centered-dots-thin"></i> ph-chat-centered-dots-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-centered-text-thin"></i> ph-chat-centered-text-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-centered-thin"></i> ph-chat-centered-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-circle-dots-thin"></i> ph-chat-circle-dots-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-circle-text-thin"></i> ph-chat-circle-text-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-circle-thin"></i> ph-chat-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-dots-thin"></i> ph-chat-dots-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-teardrop-dots-thin"></i> ph-chat-teardrop-dots-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-teardrop-text-thin"></i> ph-chat-teardrop-text-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-teardrop-thin"></i> ph-chat-teardrop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-text-thin"></i> ph-chat-text-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chat-thin"></i> ph-chat-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chats-circle-thin"></i> ph-chats-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chats-teardrop-thin"></i> ph-chats-teardrop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-chats-thin"></i> ph-chats-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-check-circle-thin"></i> ph-check-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-check-square-offset-thin"></i> ph-check-square-offset-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-check-square-thin"></i> ph-check-square-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-check-thin"></i> ph-check-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-checks-thin"></i> ph-checks-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-dashed-thin"></i> ph-circle-dashed-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-half-thin"></i> ph-circle-half-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-half-tilt-thin"></i> ph-circle-half-tilt-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-notch-thin"></i> ph-circle-notch-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-thin"></i> ph-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-wavy-check-thin"></i> ph-circle-wavy-check-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-wavy-question-thin"></i> ph-circle-wavy-question-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-wavy-thin"></i> ph-circle-wavy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circle-wavy-warning-thin"></i> ph-circle-wavy-warning-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circles-four-thin"></i> ph-circles-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circles-three-plus-thin"></i> ph-circles-three-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-circles-three-thin"></i> ph-circles-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-clipboard-text-thin"></i> ph-clipboard-text-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-clipboard-thin"></i> ph-clipboard-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-clock-afternoon-thin"></i> ph-clock-afternoon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-clock-clockwise-thin"></i> ph-clock-clockwise-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-clock-counter-clockwise-thin"></i> ph-clock-counter-clockwise-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-clock-thin"></i> ph-clock-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-closed-captioning-thin"></i> ph-closed-captioning-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-arrow-down-thin"></i> ph-cloud-arrow-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-arrow-up-thin"></i> ph-cloud-arrow-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-check-thin"></i> ph-cloud-check-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-fog-thin"></i> ph-cloud-fog-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-lightning-thin"></i> ph-cloud-lightning-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-moon-thin"></i> ph-cloud-moon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-rain-thin"></i> ph-cloud-rain-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-slash-thin"></i> ph-cloud-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-snow-thin"></i> ph-cloud-snow-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-sun-thin"></i> ph-cloud-sun-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cloud-thin"></i> ph-cloud-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-club-thin"></i> ph-club-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-coat-hanger-thin"></i> ph-coat-hanger-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-code-simple-thin"></i> ph-code-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-code-thin"></i> ph-code-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-codepen-logo-thin"></i> ph-codepen-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-codesandbox-logo-thin"></i> ph-codesandbox-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-coffee-thin"></i> ph-coffee-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-coin-thin"></i> ph-coin-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-coin-vertical-thin"></i> ph-coin-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-coins-thin"></i> ph-coins-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-columns-thin"></i> ph-columns-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-command-thin"></i> ph-command-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-compass-thin"></i> ph-compass-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-computer-tower-thin"></i> ph-computer-tower-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-confetti-thin"></i> ph-confetti-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cookie-thin"></i> ph-cookie-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cooking-pot-thin"></i> ph-cooking-pot-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-copy-simple-thin"></i> ph-copy-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-copy-thin"></i> ph-copy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-copyleft-thin"></i> ph-copyleft-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-copyright-thin"></i> ph-copyright-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-corners-in-thin"></i> ph-corners-in-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-corners-out-thin"></i> ph-corners-out-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cpu-thin"></i> ph-cpu-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-credit-card-thin"></i> ph-credit-card-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-crop-thin"></i> ph-crop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-crosshair-simple-thin"></i> ph-crosshair-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-crosshair-thin"></i> ph-crosshair-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-crown-simple-thin"></i> ph-crown-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-crown-thin"></i> ph-crown-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cube-thin"></i> ph-cube-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-btc-thin"></i> ph-currency-btc-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-circle-dollar-thin"></i> ph-currency-circle-dollar-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-cny-thin"></i> ph-currency-cny-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-dollar-simple-thin"></i> ph-currency-dollar-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-dollar-thin"></i> ph-currency-dollar-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-eth-thin"></i> ph-currency-eth-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-eur-thin"></i> ph-currency-eur-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-gbp-thin"></i> ph-currency-gbp-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-inr-thin"></i> ph-currency-inr-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-jpy-thin"></i> ph-currency-jpy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-krw-thin"></i> ph-currency-krw-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-kzt-thin"></i> ph-currency-kzt-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-ngn-thin"></i> ph-currency-ngn-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-currency-rub-thin"></i> ph-currency-rub-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cursor-text-thin"></i> ph-cursor-text-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cursor-thin"></i> ph-cursor-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-cylinder-thin"></i> ph-cylinder-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-database-thin"></i> ph-database-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-desktop-thin"></i> ph-desktop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-desktop-tower-thin"></i> ph-desktop-tower-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-detective-thin"></i> ph-detective-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-device-mobile-camera-thin"></i> ph-device-mobile-camera-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-device-mobile-speaker-thin"></i> ph-device-mobile-speaker-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-device-mobile-thin"></i> ph-device-mobile-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-device-tablet-camera-thin"></i> ph-device-tablet-camera-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-device-tablet-speaker-thin"></i> ph-device-tablet-speaker-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-device-tablet-thin"></i> ph-device-tablet-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-diamond-thin"></i> ph-diamond-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-diamonds-four-thin"></i> ph-diamonds-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dice-five-thin"></i> ph-dice-five-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dice-four-thin"></i> ph-dice-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dice-one-thin"></i> ph-dice-one-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dice-six-thin"></i> ph-dice-six-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dice-three-thin"></i> ph-dice-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dice-two-thin"></i> ph-dice-two-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-disc-thin"></i> ph-disc-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-discord-logo-thin"></i> ph-discord-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-divide-thin"></i> ph-divide-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dog-thin"></i> ph-dog-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-door-thin"></i> ph-door-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-nine-thin"></i> ph-dots-nine-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-six-thin"></i> ph-dots-six-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-six-vertical-thin"></i> ph-dots-six-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-three-circle-thin"></i> ph-dots-three-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-three-circle-vertical-thin"></i> ph-dots-three-circle-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-three-outline-thin"></i> ph-dots-three-outline-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-three-outline-vertical-thin"></i> ph-dots-three-outline-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-three-thin"></i> ph-dots-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dots-three-vertical-thin"></i> ph-dots-three-vertical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-download-simple-thin"></i> ph-download-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-download-thin"></i> ph-download-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-dribbble-logo-thin"></i> ph-dribbble-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-drop-half-bottom-thin"></i> ph-drop-half-bottom-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-drop-half-thin"></i> ph-drop-half-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-drop-thin"></i> ph-drop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ear-slash-thin"></i> ph-ear-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ear-thin"></i> ph-ear-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-egg-crack-thin"></i> ph-egg-crack-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-egg-thin"></i> ph-egg-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eject-simple-thin"></i> ph-eject-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eject-thin"></i> ph-eject-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-envelope-open-thin"></i> ph-envelope-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-envelope-simple-open-thin"></i> ph-envelope-simple-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-envelope-simple-thin"></i> ph-envelope-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-envelope-thin"></i> ph-envelope-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-equalizer-thin"></i> ph-equalizer-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-equals-thin"></i> ph-equals-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eraser-thin"></i> ph-eraser-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-exam-thin"></i> ph-exam-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-export-thin"></i> ph-export-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eye-closed-thin"></i> ph-eye-closed-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eye-slash-thin"></i> ph-eye-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eye-thin"></i> ph-eye-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eyedropper-sample-thin"></i> ph-eyedropper-sample-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eyedropper-thin"></i> ph-eyedropper-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-eyeglasses-thin"></i> ph-eyeglasses-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-face-mask-thin"></i> ph-face-mask-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-facebook-logo-thin"></i> ph-facebook-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-factory-thin"></i> ph-factory-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-faders-horizontal-thin"></i> ph-faders-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-faders-thin"></i> ph-faders-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fast-forward-circle-thin"></i> ph-fast-forward-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fast-forward-thin"></i> ph-fast-forward-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-figma-logo-thin"></i> ph-figma-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-arrow-down-thin"></i> ph-file-arrow-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-arrow-up-thin"></i> ph-file-arrow-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-audio-thin"></i> ph-file-audio-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-cloud-thin"></i> ph-file-cloud-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-code-thin"></i> ph-file-code-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-css-thin"></i> ph-file-css-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-csv-thin"></i> ph-file-csv-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-doc-thin"></i> ph-file-doc-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-dotted-thin"></i> ph-file-dotted-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-html-thin"></i> ph-file-html-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-image-thin"></i> ph-file-image-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-jpg-thin"></i> ph-file-jpg-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-js-thin"></i> ph-file-js-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-jsx-thin"></i> ph-file-jsx-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-lock-thin"></i> ph-file-lock-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-minus-thin"></i> ph-file-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-pdf-thin"></i> ph-file-pdf-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-plus-thin"></i> ph-file-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-png-thin"></i> ph-file-png-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-ppt-thin"></i> ph-file-ppt-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-rs-thin"></i> ph-file-rs-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-search-thin"></i> ph-file-search-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-text-thin"></i> ph-file-text-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-thin"></i> ph-file-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-ts-thin"></i> ph-file-ts-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-tsx-thin"></i> ph-file-tsx-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-video-thin"></i> ph-file-video-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-vue-thin"></i> ph-file-vue-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-x-thin"></i> ph-file-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-xls-thin"></i> ph-file-xls-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-file-zip-thin"></i> ph-file-zip-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-files-thin"></i> ph-files-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-film-script-thin"></i> ph-film-script-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-film-slate-thin"></i> ph-film-slate-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-film-strip-thin"></i> ph-film-strip-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fingerprint-simple-thin"></i> ph-fingerprint-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fingerprint-thin"></i> ph-fingerprint-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-finn-the-human-thin"></i> ph-finn-the-human-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fire-simple-thin"></i> ph-fire-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fire-thin"></i> ph-fire-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-first-aid-kit-thin"></i> ph-first-aid-kit-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-first-aid-thin"></i> ph-first-aid-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fish-simple-thin"></i> ph-fish-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fish-thin"></i> ph-fish-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flag-banner-thin"></i> ph-flag-banner-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flag-checkered-thin"></i> ph-flag-checkered-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flag-thin"></i> ph-flag-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flame-thin"></i> ph-flame-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flashlight-thin"></i> ph-flashlight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flask-thin"></i> ph-flask-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-floppy-disk-back-thin"></i> ph-floppy-disk-back-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-floppy-disk-thin"></i> ph-floppy-disk-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flow-arrow-thin"></i> ph-flow-arrow-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flower-lotus-thin"></i> ph-flower-lotus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flower-thin"></i> ph-flower-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-flying-saucer-thin"></i> ph-flying-saucer-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-dotted-thin"></i> ph-folder-dotted-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-lock-thin"></i> ph-folder-lock-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-minus-thin"></i> ph-folder-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-notch-minus-thin"></i> ph-folder-notch-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-notch-open-thin"></i> ph-folder-notch-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-notch-plus-thin"></i> ph-folder-notch-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-notch-thin"></i> ph-folder-notch-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-open-thin"></i> ph-folder-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-plus-thin"></i> ph-folder-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-simple-dotted-thin"></i> ph-folder-simple-dotted-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-simple-lock-thin"></i> ph-folder-simple-lock-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-simple-minus-thin"></i> ph-folder-simple-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-simple-plus-thin"></i> ph-folder-simple-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-simple-star-thin"></i> ph-folder-simple-star-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-simple-thin"></i> ph-folder-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-simple-user-thin"></i> ph-folder-simple-user-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-star-thin"></i> ph-folder-star-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-thin"></i> ph-folder-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folder-user-thin"></i> ph-folder-user-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-folders-thin"></i> ph-folders-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-football-thin"></i> ph-football-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-fork-knife-thin"></i> ph-fork-knife-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-frame-corners-thin"></i> ph-frame-corners-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-framer-logo-thin"></i> ph-framer-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-function-thin"></i> ph-function-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-funnel-simple-thin"></i> ph-funnel-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-funnel-thin"></i> ph-funnel-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-game-controller-thin"></i> ph-game-controller-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gas-pump-thin"></i> ph-gas-pump-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gauge-thin"></i> ph-gauge-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gear-six-thin"></i> ph-gear-six-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gear-thin"></i> ph-gear-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gender-female-thin"></i> ph-gender-female-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gender-intersex-thin"></i> ph-gender-intersex-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gender-male-thin"></i> ph-gender-male-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gender-neuter-thin"></i> ph-gender-neuter-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gender-nonbinary-thin"></i> ph-gender-nonbinary-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gender-transgender-thin"></i> ph-gender-transgender-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ghost-thin"></i> ph-ghost-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gif-thin"></i> ph-gif-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gift-thin"></i> ph-gift-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-git-branch-thin"></i> ph-git-branch-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-git-commit-thin"></i> ph-git-commit-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-git-diff-thin"></i> ph-git-diff-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-git-fork-thin"></i> ph-git-fork-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-git-merge-thin"></i> ph-git-merge-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-git-pull-request-thin"></i> ph-git-pull-request-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-github-logo-thin"></i> ph-github-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gitlab-logo-simple-thin"></i> ph-gitlab-logo-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gitlab-logo-thin"></i> ph-gitlab-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-globe-hemisphere-east-thin"></i> ph-globe-hemisphere-east-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-globe-hemisphere-west-thin"></i> ph-globe-hemisphere-west-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-globe-simple-thin"></i> ph-globe-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-globe-stand-thin"></i> ph-globe-stand-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-globe-thin"></i> ph-globe-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-google-chrome-logo-thin"></i> ph-google-chrome-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-google-logo-thin"></i> ph-google-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-google-photos-logo-thin"></i> ph-google-photos-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-google-play-logo-thin"></i> ph-google-play-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-google-podcasts-logo-thin"></i> ph-google-podcasts-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-gradient-thin"></i> ph-gradient-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-graduation-cap-thin"></i> ph-graduation-cap-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-graph-thin"></i> ph-graph-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-grid-four-thin"></i> ph-grid-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hamburger-thin"></i> ph-hamburger-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-eye-thin"></i> ph-hand-eye-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-fist-thin"></i> ph-hand-fist-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-grabbing-thin"></i> ph-hand-grabbing-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-palm-thin"></i> ph-hand-palm-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-pointing-thin"></i> ph-hand-pointing-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-soap-thin"></i> ph-hand-soap-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-thin"></i> ph-hand-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hand-waving-thin"></i> ph-hand-waving-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-handbag-simple-thin"></i> ph-handbag-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-handbag-thin"></i> ph-handbag-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hands-clapping-thin"></i> ph-hands-clapping-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-handshake-thin"></i> ph-handshake-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hard-drive-thin"></i> ph-hard-drive-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hard-drives-thin"></i> ph-hard-drives-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hash-straight-thin"></i> ph-hash-straight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hash-thin"></i> ph-hash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-headlights-thin"></i> ph-headlights-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-headphones-thin"></i> ph-headphones-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-headset-thin"></i> ph-headset-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-heart-break-thin"></i> ph-heart-break-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-heart-straight-break-thin"></i> ph-heart-straight-break-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-heart-straight-thin"></i> ph-heart-straight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-heart-thin"></i> ph-heart-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-heartbeat-thin"></i> ph-heartbeat-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hexagon-thin"></i> ph-hexagon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-highlighter-circle-thin"></i> ph-highlighter-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-horse-thin"></i> ph-horse-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-high-thin"></i> ph-hourglass-high-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-low-thin"></i> ph-hourglass-low-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-medium-thin"></i> ph-hourglass-medium-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-simple-high-thin"></i> ph-hourglass-simple-high-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-simple-low-thin"></i> ph-hourglass-simple-low-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-simple-medium-thin"></i> ph-hourglass-simple-medium-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-simple-thin"></i> ph-hourglass-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-hourglass-thin"></i> ph-hourglass-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-house-line-thin"></i> ph-house-line-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-house-simple-thin"></i> ph-house-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-house-thin"></i> ph-house-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-identification-badge-thin"></i> ph-identification-badge-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-identification-card-thin"></i> ph-identification-card-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-image-square-thin"></i> ph-image-square-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-image-thin"></i> ph-image-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-infinity-thin"></i> ph-infinity-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-info-thin"></i> ph-info-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-instagram-logo-thin"></i> ph-instagram-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-intersect-thin"></i> ph-intersect-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-jeep-thin"></i> ph-jeep-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-kanban-thin"></i> ph-kanban-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-key-return-thin"></i> ph-key-return-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-key-thin"></i> ph-key-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-keyboard-thin"></i> ph-keyboard-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-keyhole-thin"></i> ph-keyhole-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-knife-thin"></i> ph-knife-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ladder-simple-thin"></i> ph-ladder-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ladder-thin"></i> ph-ladder-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lamp-thin"></i> ph-lamp-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-laptop-thin"></i> ph-laptop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-layout-thin"></i> ph-layout-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-leaf-thin"></i> ph-leaf-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lifebuoy-thin"></i> ph-lifebuoy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lightbulb-filament-thin"></i> ph-lightbulb-filament-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lightbulb-thin"></i> ph-lightbulb-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lightning-slash-thin"></i> ph-lightning-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lightning-thin"></i> ph-lightning-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-line-segment-thin"></i> ph-line-segment-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-line-segments-thin"></i> ph-line-segments-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-link-break-thin"></i> ph-link-break-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-link-simple-break-thin"></i> ph-link-simple-break-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-link-simple-horizontal-break-thin"></i> ph-link-simple-horizontal-break-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-link-simple-horizontal-thin"></i> ph-link-simple-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-link-simple-thin"></i> ph-link-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-link-thin"></i> ph-link-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-linkedin-logo-thin"></i> ph-linkedin-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-linux-logo-thin"></i> ph-linux-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-list-bullets-thin"></i> ph-list-bullets-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-list-checks-thin"></i> ph-list-checks-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-list-dashes-thin"></i> ph-list-dashes-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-list-numbers-thin"></i> ph-list-numbers-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-list-plus-thin"></i> ph-list-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-list-thin"></i> ph-list-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-key-open-thin"></i> ph-lock-key-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-key-thin"></i> ph-lock-key-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-laminated-open-thin"></i> ph-lock-laminated-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-laminated-thin"></i> ph-lock-laminated-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-open-thin"></i> ph-lock-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-simple-open-thin"></i> ph-lock-simple-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-simple-thin"></i> ph-lock-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-lock-thin"></i> ph-lock-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-magic-wand-thin"></i> ph-magic-wand-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-magnet-straight-thin"></i> ph-magnet-straight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-magnet-thin"></i> ph-magnet-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-magnifying-glass-minus-thin"></i> ph-magnifying-glass-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-magnifying-glass-plus-thin"></i> ph-magnifying-glass-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-magnifying-glass-thin"></i> ph-magnifying-glass-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-map-pin-line-thin"></i> ph-map-pin-line-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-map-pin-thin"></i> ph-map-pin-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-map-trifold-thin"></i> ph-map-trifold-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-marker-circle-thin"></i> ph-marker-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-martini-thin"></i> ph-martini-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-mask-happy-thin"></i> ph-mask-happy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-mask-sad-thin"></i> ph-mask-sad-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-math-operations-thin"></i> ph-math-operations-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-medal-thin"></i> ph-medal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-medium-logo-thin"></i> ph-medium-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-megaphone-simple-thin"></i> ph-megaphone-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-megaphone-thin"></i> ph-megaphone-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-messenger-logo-thin"></i> ph-messenger-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-microphone-slash-thin"></i> ph-microphone-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-microphone-stage-thin"></i> ph-microphone-stage-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-microphone-thin"></i> ph-microphone-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-microsoft-excel-logo-thin"></i> ph-microsoft-excel-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-microsoft-powerpoint-logo-thin"></i> ph-microsoft-powerpoint-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-microsoft-teams-logo-thin"></i> ph-microsoft-teams-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-microsoft-word-logo-thin"></i> ph-microsoft-word-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-minus-circle-thin"></i> ph-minus-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-minus-thin"></i> ph-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-money-thin"></i> ph-money-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-monitor-play-thin"></i> ph-monitor-play-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-monitor-thin"></i> ph-monitor-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-moon-stars-thin"></i> ph-moon-stars-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-moon-thin"></i> ph-moon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-mountains-thin"></i> ph-mountains-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-mouse-simple-thin"></i> ph-mouse-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-mouse-thin"></i> ph-mouse-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-music-note-simple-thin"></i> ph-music-note-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-music-note-thin"></i> ph-music-note-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-music-notes-plus-thin"></i> ph-music-notes-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-music-notes-simple-thin"></i> ph-music-notes-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-music-notes-thin"></i> ph-music-notes-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-navigation-arrow-thin"></i> ph-navigation-arrow-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-needle-thin"></i> ph-needle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-newspaper-clipping-thin"></i> ph-newspaper-clipping-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-newspaper-thin"></i> ph-newspaper-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-note-blank-thin"></i> ph-note-blank-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-note-pencil-thin"></i> ph-note-pencil-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-note-thin"></i> ph-note-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-notebook-thin"></i> ph-notebook-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-notepad-thin"></i> ph-notepad-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-notification-thin"></i> ph-notification-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-eight-thin"></i> ph-number-circle-eight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-five-thin"></i> ph-number-circle-five-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-four-thin"></i> ph-number-circle-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-nine-thin"></i> ph-number-circle-nine-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-one-thin"></i> ph-number-circle-one-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-seven-thin"></i> ph-number-circle-seven-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-six-thin"></i> ph-number-circle-six-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-three-thin"></i> ph-number-circle-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-two-thin"></i> ph-number-circle-two-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-circle-zero-thin"></i> ph-number-circle-zero-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-eight-thin"></i> ph-number-eight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-five-thin"></i> ph-number-five-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-four-thin"></i> ph-number-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-nine-thin"></i> ph-number-nine-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-one-thin"></i> ph-number-one-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-seven-thin"></i> ph-number-seven-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-six-thin"></i> ph-number-six-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-eight-thin"></i> ph-number-square-eight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-five-thin"></i> ph-number-square-five-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-four-thin"></i> ph-number-square-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-nine-thin"></i> ph-number-square-nine-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-one-thin"></i> ph-number-square-one-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-seven-thin"></i> ph-number-square-seven-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-six-thin"></i> ph-number-square-six-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-three-thin"></i> ph-number-square-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-two-thin"></i> ph-number-square-two-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-square-zero-thin"></i> ph-number-square-zero-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-three-thin"></i> ph-number-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-two-thin"></i> ph-number-two-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-number-zero-thin"></i> ph-number-zero-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-nut-thin"></i> ph-nut-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ny-times-logo-thin"></i> ph-ny-times-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-octagon-thin"></i> ph-octagon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-option-thin"></i> ph-option-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-package-thin"></i> ph-package-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paint-brush-broad-thin"></i> ph-paint-brush-broad-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paint-brush-household-thin"></i> ph-paint-brush-household-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paint-brush-thin"></i> ph-paint-brush-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paint-bucket-thin"></i> ph-paint-bucket-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paint-roller-thin"></i> ph-paint-roller-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-palette-thin"></i> ph-palette-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paper-plane-right-thin"></i> ph-paper-plane-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paper-plane-thin"></i> ph-paper-plane-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paper-plane-tilt-thin"></i> ph-paper-plane-tilt-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paperclip-horizontal-thin"></i> ph-paperclip-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paperclip-thin"></i> ph-paperclip-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-parachute-thin"></i> ph-parachute-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-password-thin"></i> ph-password-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-path-thin"></i> ph-path-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pause-circle-thin"></i> ph-pause-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pause-thin"></i> ph-pause-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-paw-print-thin"></i> ph-paw-print-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-peace-thin"></i> ph-peace-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pen-nib-straight-thin"></i> ph-pen-nib-straight-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pen-nib-thin"></i> ph-pen-nib-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pen-thin"></i> ph-pen-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pencil-circle-thin"></i> ph-pencil-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pencil-line-thin"></i> ph-pencil-line-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pencil-simple-line-thin"></i> ph-pencil-simple-line-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pencil-simple-thin"></i> ph-pencil-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pencil-thin"></i> ph-pencil-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-percent-thin"></i> ph-percent-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-person-simple-run-thin"></i> ph-person-simple-run-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-person-simple-thin"></i> ph-person-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-person-simple-walk-thin"></i> ph-person-simple-walk-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-person-thin"></i> ph-person-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-perspective-thin"></i> ph-perspective-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phone-call-thin"></i> ph-phone-call-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phone-disconnect-thin"></i> ph-phone-disconnect-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phone-incoming-thin"></i> ph-phone-incoming-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phone-outgoing-thin"></i> ph-phone-outgoing-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phone-slash-thin"></i> ph-phone-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phone-thin"></i> ph-phone-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phone-x-thin"></i> ph-phone-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-phosphor-logo-thin"></i> ph-phosphor-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-piano-keys-thin"></i> ph-piano-keys-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-picture-in-picture-thin"></i> ph-picture-in-picture-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pill-thin"></i> ph-pill-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pinterest-logo-thin"></i> ph-pinterest-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pinwheel-thin"></i> ph-pinwheel-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-pizza-thin"></i> ph-pizza-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-placeholder-thin"></i> ph-placeholder-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-planet-thin"></i> ph-planet-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-play-circle-thin"></i> ph-play-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-play-thin"></i> ph-play-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-playlist-thin"></i> ph-playlist-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-plug-thin"></i> ph-plug-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-plugs-connected-thin"></i> ph-plugs-connected-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-plugs-thin"></i> ph-plugs-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-plus-circle-thin"></i> ph-plus-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-plus-minus-thin"></i> ph-plus-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-plus-thin"></i> ph-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-poker-chip-thin"></i> ph-poker-chip-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-police-car-thin"></i> ph-police-car-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-polygon-thin"></i> ph-polygon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-popcorn-thin"></i> ph-popcorn-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-power-thin"></i> ph-power-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-prescription-thin"></i> ph-prescription-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-presentation-chart-thin"></i> ph-presentation-chart-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-presentation-thin"></i> ph-presentation-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-printer-thin"></i> ph-printer-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-prohibit-inset-thin"></i> ph-prohibit-inset-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-prohibit-thin"></i> ph-prohibit-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-projector-screen-chart-thin"></i> ph-projector-screen-chart-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-projector-screen-thin"></i> ph-projector-screen-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-push-pin-simple-slash-thin"></i> ph-push-pin-simple-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-push-pin-simple-thin"></i> ph-push-pin-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-push-pin-slash-thin"></i> ph-push-pin-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-push-pin-thin"></i> ph-push-pin-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-puzzle-piece-thin"></i> ph-puzzle-piece-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-qr-code-thin"></i> ph-qr-code-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-question-thin"></i> ph-question-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-queue-thin"></i> ph-queue-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-quotes-thin"></i> ph-quotes-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-radical-thin"></i> ph-radical-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-radio-button-thin"></i> ph-radio-button-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-radio-thin"></i> ph-radio-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rainbow-cloud-thin"></i> ph-rainbow-cloud-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rainbow-thin"></i> ph-rainbow-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-receipt-thin"></i> ph-receipt-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-record-thin"></i> ph-record-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rectangle-thin"></i> ph-rectangle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-recycle-thin"></i> ph-recycle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-reddit-logo-thin"></i> ph-reddit-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-repeat-once-thin"></i> ph-repeat-once-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-repeat-thin"></i> ph-repeat-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rewind-circle-thin"></i> ph-rewind-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rewind-thin"></i> ph-rewind-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-robot-thin"></i> ph-robot-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rocket-launch-thin"></i> ph-rocket-launch-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rocket-thin"></i> ph-rocket-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rows-thin"></i> ph-rows-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rss-simple-thin"></i> ph-rss-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rss-thin"></i> ph-rss-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-rug-thin"></i> ph-rug-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ruler-thin"></i> ph-ruler-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-scales-thin"></i> ph-scales-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-scan-thin"></i> ph-scan-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-scissors-thin"></i> ph-scissors-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-screencast-thin"></i> ph-screencast-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-scribble-loop-thin"></i> ph-scribble-loop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-scroll-thin"></i> ph-scroll-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-selection-all-thin"></i> ph-selection-all-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-selection-background-thin"></i> ph-selection-background-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-selection-foreground-thin"></i> ph-selection-foreground-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-selection-inverse-thin"></i> ph-selection-inverse-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-selection-plus-thin"></i> ph-selection-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-selection-slash-thin"></i> ph-selection-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-selection-thin"></i> ph-selection-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-share-network-thin"></i> ph-share-network-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-share-thin"></i> ph-share-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-check-thin"></i> ph-shield-check-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-checkered-thin"></i> ph-shield-checkered-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-chevron-thin"></i> ph-shield-chevron-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-plus-thin"></i> ph-shield-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-slash-thin"></i> ph-shield-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-star-thin"></i> ph-shield-star-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-thin"></i> ph-shield-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shield-warning-thin"></i> ph-shield-warning-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shopping-bag-open-thin"></i> ph-shopping-bag-open-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shopping-bag-thin"></i> ph-shopping-bag-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shopping-cart-simple-thin"></i> ph-shopping-cart-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shopping-cart-thin"></i> ph-shopping-cart-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shower-thin"></i> ph-shower-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shuffle-angular-thin"></i> ph-shuffle-angular-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shuffle-simple-thin"></i> ph-shuffle-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-shuffle-thin"></i> ph-shuffle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sidebar-simple-thin"></i> ph-sidebar-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sidebar-thin"></i> ph-sidebar-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sign-in-thin"></i> ph-sign-in-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sign-out-thin"></i> ph-sign-out-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-signpost-thin"></i> ph-signpost-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sim-card-thin"></i> ph-sim-card-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sketch-logo-thin"></i> ph-sketch-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-skip-back-circle-thin"></i> ph-skip-back-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-skip-back-thin"></i> ph-skip-back-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-skip-forward-circle-thin"></i> ph-skip-forward-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-skip-forward-thin"></i> ph-skip-forward-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-skull-thin"></i> ph-skull-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-slack-logo-thin"></i> ph-slack-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sliders-horizontal-thin"></i> ph-sliders-horizontal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sliders-thin"></i> ph-sliders-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-blank-thin"></i> ph-smiley-blank-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-meh-thin"></i> ph-smiley-meh-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-nervous-thin"></i> ph-smiley-nervous-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-sad-thin"></i> ph-smiley-sad-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-sticker-thin"></i> ph-smiley-sticker-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-thin"></i> ph-smiley-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-wink-thin"></i> ph-smiley-wink-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-smiley-x-eyes-thin"></i> ph-smiley-x-eyes-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-snapchat-logo-thin"></i> ph-snapchat-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-snowflake-thin"></i> ph-snowflake-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-soccer-ball-thin"></i> ph-soccer-ball-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sort-ascending-thin"></i> ph-sort-ascending-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sort-descending-thin"></i> ph-sort-descending-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-spade-thin"></i> ph-spade-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sparkle-thin"></i> ph-sparkle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-high-thin"></i> ph-speaker-high-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-low-thin"></i> ph-speaker-low-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-none-thin"></i> ph-speaker-none-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-simple-high-thin"></i> ph-speaker-simple-high-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-simple-low-thin"></i> ph-speaker-simple-low-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-simple-none-thin"></i> ph-speaker-simple-none-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-simple-slash-thin"></i> ph-speaker-simple-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-simple-x-thin"></i> ph-speaker-simple-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-slash-thin"></i> ph-speaker-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-speaker-x-thin"></i> ph-speaker-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-spinner-gap-thin"></i> ph-spinner-gap-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-spinner-thin"></i> ph-spinner-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-spiral-thin"></i> ph-spiral-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-spotify-logo-thin"></i> ph-spotify-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-square-half-bottom-thin"></i> ph-square-half-bottom-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-square-half-thin"></i> ph-square-half-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-square-logo-thin"></i> ph-square-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-square-thin"></i> ph-square-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-squares-four-thin"></i> ph-squares-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-stack-overflow-logo-thin"></i> ph-stack-overflow-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-stack-simple-thin"></i> ph-stack-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-stack-thin"></i> ph-stack-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-stamp-thin"></i> ph-stamp-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-star-four-thin"></i> ph-star-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-star-half-thin"></i> ph-star-half-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-star-thin"></i> ph-star-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sticker-thin"></i> ph-sticker-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-stop-circle-thin"></i> ph-stop-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-stop-thin"></i> ph-stop-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-storefront-thin"></i> ph-storefront-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-strategy-thin"></i> ph-strategy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-stripe-logo-thin"></i> ph-stripe-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-student-thin"></i> ph-student-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-suitcase-simple-thin"></i> ph-suitcase-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-suitcase-thin"></i> ph-suitcase-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sun-dim-thin"></i> ph-sun-dim-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sun-horizon-thin"></i> ph-sun-horizon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sun-thin"></i> ph-sun-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sunglasses-thin"></i> ph-sunglasses-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-swap-thin"></i> ph-swap-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-swatches-thin"></i> ph-swatches-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-sword-thin"></i> ph-sword-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-syringe-thin"></i> ph-syringe-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-t-shirt-thin"></i> ph-t-shirt-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-table-thin"></i> ph-table-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tabs-thin"></i> ph-tabs-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tag-chevron-thin"></i> ph-tag-chevron-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tag-simple-thin"></i> ph-tag-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tag-thin"></i> ph-tag-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-target-thin"></i> ph-target-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-taxi-thin"></i> ph-taxi-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-telegram-logo-thin"></i> ph-telegram-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-television-simple-thin"></i> ph-television-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-television-thin"></i> ph-television-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tennis-ball-thin"></i> ph-tennis-ball-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-terminal-thin"></i> ph-terminal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-terminal-window-thin"></i> ph-terminal-window-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-test-tube-thin"></i> ph-test-tube-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-aa-thin"></i> ph-text-aa-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-align-center-thin"></i> ph-text-align-center-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-align-justify-thin"></i> ph-text-align-justify-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-align-left-thin"></i> ph-text-align-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-align-right-thin"></i> ph-text-align-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-bolder-thin"></i> ph-text-bolder-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-h-five-thin"></i> ph-text-h-five-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-h-four-thin"></i> ph-text-h-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-h-one-thin"></i> ph-text-h-one-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-h-six-thin"></i> ph-text-h-six-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-h-thin"></i> ph-text-h-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-h-three-thin"></i> ph-text-h-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-h-two-thin"></i> ph-text-h-two-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-indent-thin"></i> ph-text-indent-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-italic-thin"></i> ph-text-italic-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-outdent-thin"></i> ph-text-outdent-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-strikethrough-thin"></i> ph-text-strikethrough-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-t-thin"></i> ph-text-t-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-text-underline-thin"></i> ph-text-underline-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-textbox-thin"></i> ph-textbox-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-thermometer-cold-thin"></i> ph-thermometer-cold-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-thermometer-hot-thin"></i> ph-thermometer-hot-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-thermometer-simple-thin"></i> ph-thermometer-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-thermometer-thin"></i> ph-thermometer-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-thumbs-down-thin"></i> ph-thumbs-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-thumbs-up-thin"></i> ph-thumbs-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-ticket-thin"></i> ph-ticket-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tiktok-logo-thin"></i> ph-tiktok-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-timer-thin"></i> ph-timer-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-toggle-left-thin"></i> ph-toggle-left-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-toggle-right-thin"></i> ph-toggle-right-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-toilet-paper-thin"></i> ph-toilet-paper-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-toilet-thin"></i> ph-toilet-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tote-simple-thin"></i> ph-tote-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tote-thin"></i> ph-tote-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-trademark-registered-thin"></i> ph-trademark-registered-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-traffic-cone-thin"></i> ph-traffic-cone-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-traffic-sign-thin"></i> ph-traffic-sign-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-traffic-signal-thin"></i> ph-traffic-signal-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-train-regional-thin"></i> ph-train-regional-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-train-simple-thin"></i> ph-train-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-train-thin"></i> ph-train-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-translate-thin"></i> ph-translate-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-trash-simple-thin"></i> ph-trash-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-trash-thin"></i> ph-trash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tray-thin"></i> ph-tray-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tree-evergreen-thin"></i> ph-tree-evergreen-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tree-structure-thin"></i> ph-tree-structure-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-tree-thin"></i> ph-tree-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-trend-down-thin"></i> ph-trend-down-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-trend-up-thin"></i> ph-trend-up-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-triangle-thin"></i> ph-triangle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-trophy-thin"></i> ph-trophy-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-truck-thin"></i> ph-truck-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-twitch-logo-thin"></i> ph-twitch-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-twitter-logo-thin"></i> ph-twitter-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-umbrella-simple-thin"></i> ph-umbrella-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-umbrella-thin"></i> ph-umbrella-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-upload-simple-thin"></i> ph-upload-simple-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-upload-thin"></i> ph-upload-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-circle-gear-thin"></i> ph-user-circle-gear-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-circle-minus-thin"></i> ph-user-circle-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-circle-plus-thin"></i> ph-user-circle-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-circle-thin"></i> ph-user-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-focus-thin"></i> ph-user-focus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-gear-thin"></i> ph-user-gear-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-list-thin"></i> ph-user-list-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-minus-thin"></i> ph-user-minus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-plus-thin"></i> ph-user-plus-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-rectangle-thin"></i> ph-user-rectangle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-square-thin"></i> ph-user-square-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-switch-thin"></i> ph-user-switch-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-user-thin"></i> ph-user-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-users-four-thin"></i> ph-users-four-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-users-thin"></i> ph-users-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-users-three-thin"></i> ph-users-three-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-vault-thin"></i> ph-vault-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-vibrate-thin"></i> ph-vibrate-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-video-camera-slash-thin"></i> ph-video-camera-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-video-camera-thin"></i> ph-video-camera-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-vignette-thin"></i> ph-vignette-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-voicemail-thin"></i> ph-voicemail-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-volleyball-thin"></i> ph-volleyball-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wall-thin"></i> ph-wall-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wallet-thin"></i> ph-wallet-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-warning-circle-thin"></i> ph-warning-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-warning-octagon-thin"></i> ph-warning-octagon-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-warning-thin"></i> ph-warning-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-watch-thin"></i> ph-watch-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wave-sawtooth-thin"></i> ph-wave-sawtooth-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wave-sine-thin"></i> ph-wave-sine-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wave-square-thin"></i> ph-wave-square-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wave-triangle-thin"></i> ph-wave-triangle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-waves-thin"></i> ph-waves-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-webcam-thin"></i> ph-webcam-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-whatsapp-logo-thin"></i> ph-whatsapp-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wheelchair-thin"></i> ph-wheelchair-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wifi-high-thin"></i> ph-wifi-high-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wifi-low-thin"></i> ph-wifi-low-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wifi-medium-thin"></i> ph-wifi-medium-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wifi-none-thin"></i> ph-wifi-none-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wifi-slash-thin"></i> ph-wifi-slash-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wifi-x-thin"></i> ph-wifi-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wind-thin"></i> ph-wind-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-windows-logo-thin"></i> ph-windows-logo-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wine-thin"></i> ph-wine-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-wrench-thin"></i> ph-wrench-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-x-circle-thin"></i> ph-x-circle-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-x-square-thin"></i> ph-x-square-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-x-thin"></i> ph-x-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-yin-yang-thin"></i> ph-yin-yang-thin
                                </Col>
                                <Col xl={3} lg={4} sm={6}>
                                    <i className="ph-youtube-logo-thin"></i> ph-youtube-logo-thin
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>
    </React.Fragment>
  );
};

export default PhosphorIcon;